import styled from "styled-components";
import { headerCommonStyle } from "./common.js";

export const H4 = styled.h4`
  ${headerCommonStyle}
  font-size: ${({ theme }) => theme.fontSize.lg};
`;
